module.exports = __webpack_public_path__ + "static/perspective.936b043d59d25afbe2ffec710b081c8e.svg";